import { CircleX } from "lucide-react";

export const ExecutionSheriffNewModal = ({ handleCancel }) => {
  return (
    <div className="Schedule_new_case_modal_wrapper">
      <div
        style={{
          borderRadius: "8px",
          maxWidth: "436px",
        }}
        className="executionSheriff-form-wrapper"
      >
        <form className="executionSheriff-form">
          <p className="executionSheriff-title">Assign To Execution Sheriff</p>
          <div className="schedule-input-btn-wrappe">
            <div className="executionSheriff-input-wrapper">
              <div className="select-group">
                <label htmlFor="executionSheriff">Execution Sheriff</label>
                <select id="executionSheriff">
                  <option>select</option>
                </select>
              </div>
              <div
                style={{
                  marginInline: "auto",
                  width: "100%",
                  maxWidth: "360px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <label
                  style={{
                    fontSize: "12px",
                  }}
                  htmlFor="comment"
                >
                  Comment
                </label>
                <textarea id="comment" />
              </div>
            </div>

            <div
              style={{
                justifyContent: "flex-end",
                maxWidth: "360px",
                width: "100%",
                marginInline: "auto",
              }}
              className="assign-case-button-group"
            >
              <button
                style={{
                  maxWidth: "132px",
                }}
                onClick={handleCancel}
                type="button"
              >
                Cancel
              </button>
              <button
                style={{
                  height: "42px",
                  maxWidth: "224px",
                }}
                className=""
              >
                Assign
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
